// generated on pe 13.5.2022 14.48.24 +0300
export const appVersion = '0.8.92';
